import { SUPPORTED_TYPES } from '../constants'
import { Type } from '../graphql/generated/autogenerated'

export default (label: Type) => SUPPORTED_TYPES.some((type) => type === label)
